import styled from 'styled-components'

export const Item = styled.div`
    height: 400px;
    border-radius: 7px;
    border: 1px solid #e4e4e4;
    box-shadow: 0 1px 5px 0 rgb(121 128 139 / 22%);
    background-color: white;
    overflow: hidden;
    margin: 20px;
    transition: box-shadow .300ms ease-out;

    &:hover {
        box-shadow: none;
    }

    @media screen and (max-width: 1100px) {
        margin: 10px;
    }

    .item-header {
        height: 40%;
        width: 100%;
        display: flex;
        user-select: none;
        background-color: rgba(228,228,228,.22);
        overflow: hidden;
        border: none;
        border-top-right-radius: 7px;
        border-top-left-radius: 7px;
        outline: none;
        cursor: pointer;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }

    .item-content {
        height: 50%;
        padding: 10px 15px;
        display: flex;
        flex-direction: column;

        > span {
            font-size: 1.1rem;
            font-weight: 500;
            margin: 8px 0;
        }

        .description {
            flex-grow: 1;
            margin: 0;
            overflow: hidden;
            font-size: 0.8rem;
            text-align: justify;
        }

        .tags {
            font-size: .7rem;
            display: flex;
            align-items: center;
            flex-wrap: wrap;

            > span {
                display: flex;
                align-items: center;
                height: 18px;
                color: #1A3549dd;
                margin: 5px 15px 0 0;
            }
        }
    }

    .item-footer {
        height: 10%;
        width: 100%;
        background-color: rgba(228,228,228,.25);
        border: none;
        border-top: 1px solid #e4e4e4;
        display: flex;
        align-items: center;
        justify-content: center;
        user-select: none;
        cursor: pointer;
        font-size: .9rem;
        color: #1A3549dd;
        outline: none;
    }
`
